import { render, staticRenderFns } from "./FormBuilderTodoDrawer.vue?vue&type=template&id=2ec509c4&"
import script from "./FormBuilderTodoDrawer.vue?vue&type=script&lang=ts&"
export * from "./FormBuilderTodoDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports